import {IBaseFormFieldSettings} from "../base-form-field.settings";


export interface IJsonFieldSettings extends IBaseFormFieldSettings {
  // todo?
}
